(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-call', {
            parent: 'entity',
            url: '/lead-call?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadCall.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-call/lead-calls.html',
                    controller: 'LeadCallController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadCall');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-call-detail', {
            parent: 'entity',
            url: '/lead-call/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadCall.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-call/lead-call-detail.html',
                    controller: 'LeadCallDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadCall');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadCall', function($stateParams, LeadCall) {
                    return LeadCall.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-call.new', {
            parent: 'lead-call',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-call/lead-call-dialog.html',
                    controller: 'LeadCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateTime: null,
                                noContact: null,
                                isOldPatient: null,
                                isOldPatientRelative: null,
                                appointmentDate: null,
                                bookedAppointment: null,
                                isImportant: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-call', null, { reload: true });
                }, function() {
                    $state.go('lead-call');
                });
            }]
        })
        .state('lead-call.edit', {
            parent: 'lead-call',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-call/lead-call-dialog.html',
                    controller: 'LeadCallDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadCall', function(LeadCall) {
                            return LeadCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-call.delete', {
            parent: 'lead-call',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-call/lead-call-delete-dialog.html',
                    controller: 'LeadCallDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadCall', function(LeadCall) {
                            return LeadCall.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-call', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
